import { FC } from "react";
import LoadingSpinner from "duck/ui/chat/components/LoadingSpinner";
import { ChatMessage } from "duck/ui/chat/types";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";

import Typography from "features/components/Typography";

interface Props {
  message: ChatMessage;
  currentlyStreaming: boolean;
}

const StatusMessageRenderer: FC<Props> = ({ message, currentlyStreaming }) => {
  const { t } = useTranslation("duck");
  const shouldRender =
    currentlyStreaming && Boolean(message.startedAt) && !message.endedAt;
  if (!shouldRender) {
    return null;
  }

  const statusMessage =
    message.backQuack?.status_update_message || t("thinking");

  return (
    <Box className="py-0.5 flex items-center gap-3 text-gray-700">
      <LoadingSpinner />
      <Typography variant="body2">{statusMessage}</Typography>
    </Box>
  );
};

export default StatusMessageRenderer;
